export const Marketing = {
  props: {
    isBacker: {
      type: Boolean
    },

    determinations: {
      type: Object
    },

    daysLeft: {
      type: Number
    },

    daysLeftLabel: {
      type: String
    },

    sku: {
      type: String
    }
  }
}
